export default __webpack_public_path__ + "static/O0220-0e1fa8c61b97b06c1a8aff3aab675d9c.png";